export const getPlayableTrackUrl = (track = {}) => (
    track.fileUrl ||
    track.audioUrl ||
    track.previewUrl ||
    track.audioFileUrl ||
    track.downloadURL ||
    track.downloadUrl ||
    track.url ||
    ''
);

export const normalizeTrackDocument = (snapshotDoc) => {
    const data = snapshotDoc.data();
    const playableUrl = getPlayableTrackUrl(data);

    return {
        id: snapshotDoc.id,
        ...data,
        fileUrl: playableUrl,
        uploadedAt: data.uploadedAt?.toDate ? data.uploadedAt.toDate() : (data.uploadedAt || data.createdAt || new Date()),
    };
};

export const hasPlayableAudio = (track = {}) => Boolean(String(getPlayableTrackUrl(track)).trim());

export const isBlockedLaunchArtist = (track = {}) => {
    const artist = String(track.artist || track.profile?.name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const userName = String(track.userName || track.username || '').toLowerCase().replace(/[^a-z0-9]/g, '');

    return artist === 'dsjs' || userName === 'dsjs';
};

export const isLiveTrack = (track = {}) => {
    const title = track.title || '';
    const artist = track.artist || '';

    return Boolean(
        title.trim() &&
        artist.trim() &&
        title.toLowerCase() !== 'preview' &&
        artist.toLowerCase() !== 'preview' &&
        track.coverImage &&
        hasPlayableAudio(track) &&
        !isBlockedLaunchArtist(track)
    );
};
